import { render } from "./CookiesBar.vue?vue&type=template&id=fdb45f26&scoped=true"
import script from "./CookiesBar.vue?vue&type=script&lang=js"
export * from "./CookiesBar.vue?vue&type=script&lang=js"

import "./CookiesBar.vue?vue&type=style&index=0&id=fdb45f26&lang=scss&scoped=true"

import exportComponent from "C:\\projets\\rivha\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdb45f26"]])

export default __exports__